/* eslint-disable */

import React from "react";
import { useLocation } from "react-router-dom";
import { useState } from "react";
// import "../../Assests/Globalimages/logo_v.jpg";
import logo from "../../Assests/images/Tip Tax usa.png";
import ficaLogo from "../../Assests/images/Tip Tax usa.png";
import { useNavigate } from "react-router-dom";
import LeadCaptureModal from "../../Componenets/LeadCaptureModal";

const Index = () => {
  const navigate = useNavigate();
  const [showModal, setShowModal] = useState(false);
  const location = useLocation();
const isFicaPage = location.pathname === "/Fica-Calculator";


  return (
    <div>
      <LeadCaptureModal showModal={showModal} setShowModal={setShowModal} />

        <section className={`nav-bar ${isFicaPage ? "fica-nav" : ""}`}>
      <div className="container">
        <nav
          className={`navbar navbar-expand-lg fixed-top py-2 ${
            isFicaPage ? "navbar-dark" : "navbar-light"
          }`}
        >
          <div className="container d-flex align-items-center justify-content-between">
            {/* Logo */}
            <a onClick={() => navigate("/")}>
              <img
                src={isFicaPage ? ficaLogo : logo} // <-- dynamic logo
                style={{ maxWidth: "150px" }}
                alt="Logo"
              />
            </a>

            <button
              className="navbar-toggler"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#navbarNav"
            >
              <i className="fa-solid fa-bars"></i>
            </button>

            <div
              className="collapse navbar-collapse justify-content-center"
              id="navbarNav"
            >
              <ul className="navbar-nav mx-auto gap-3 align-items-center">
                {["How It Works", "Benefits", "Faqs"].map((text, index) => {
                  const id = text.toLowerCase().replace(/\s+/g, "");
                  return (
                    <li className="nav-item" key={index}>
                      <a
                        className={`nav-link ${isFicaPage ? "fica-text" : ""}`}
                        style={{ cursor: "pointer" }}
                        onClick={() => {
                          navigate(`/#${id}`);
                          setTimeout(() => {
                            const el = document.getElementById(id);
                            if (el) el.scrollIntoView({ behavior: "smooth" });
                          }, 300);
                        }}
                      >
                        {text}
                      </a>
                    </li>
                  );
                })}
              </ul>

              <div className="d-flex gap-2">
                <a
                  className={`nav-link cardbtun px-3 py-2 ${
                    isFicaPage ? "fica-btn" : ""
                  }`}
                onClick={() => setShowModal(true)}
                 style={{cursor:"pointer"}}
                >
                  Get Started
                </a>
                {/* <a
                  className={`nav-link cardbtun2 px-3 py-2 ${
                    isFicaPage ? "fica-btn2" : ""
                  }`}
                onClick={() => setShowModal(true)}
                style={{cursor:"pointer"}}
                >
                  Login
                </a> */}
              </div>
            </div>
          </div>
        </nav>
      </div>
    </section>
      {/* <LeadCaptureModal showModal={showModal} setShowModal={setShowModal} /> */}
    </div>
  );
};

export default Index;
